import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "app-stage"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AppLoadingOverlay = _resolveComponent("AppLoadingOverlay");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  return _openBlock(), _createBlock(_component_el_config_provider, {
    locale: _ctx.locale
  }, {
    default: _withCtx(() => [!$options.isAdminRoute ? (_openBlock(), _createBlock(_component_AppLoadingOverlay, {
      key: 0
    })) : _createCommentVNode("", true), _ctx.appStore.bootstrapReady || $options.isAdminRoute ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["locale"]);
}